import { global } from './global.js'

export let helpers = {
  b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    let byteCharacters = atob(b64Data);
    let byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);

      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
      }

      let byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    let blob = new Blob(byteArrays, {type: contentType});
    return blob;
  },
  getImageData(b64Data) {
    let block = b64Data.split(";");
    return {
      b64Data: block[1].split(",")[1],
      contentType: block[0].split(":")[1]
    }
  },
  createFile(fileName, content, appendUrl) {
    global.log(fileName, typeof content);
    //console.log('create', fileName);
    window.requestFileSystem(LocalFileSystem.PERSISTENT, 0, (fs) => {
      //console.log('file system open: ' + fs.name);
      fs.root.getFile(fileName, { create: true, exclusive: false }, (fileEntry) => {
          //console.log("fileEntry is file? " + fileEntry.isFile.toString());
          this.writeFile(fileEntry, content, appendUrl, fileName);
      }, onErrorCreateFile);
    }, onErrorLoadFs);

    function onErrorCreateFile(error) {
      console.log('onErrorCreateFile', error);
    }

    function onErrorLoadFs(error) {
      console.log('onErrorLoadFs', error);
    }
  },
  writeFile(fileEntry, content, appendUrl, fileName) {
    // Create a FileWriter object for our FileEntry.
    fileEntry.createWriter(fileWriter => {
      fileWriter.onwriteend = () => {
        //console.log("Successful file write...");
        appendUrl(fileEntry.toURL());
      };

      fileWriter.onerror = (e) => {
        console.log("Failed file write: " + fileName + ' ' + e.toString());
      };

      fileWriter.write(content);
    });
  }
};



// WEBPACK FOOTER //
// ./src/helpers.js